import React, { useState } from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

import Markdown from 'markdown-to-jsx';
import Head from 'next/head';
import Image from 'next/image';
import { truncateText } from '../../utils/utilFunctions';
import mark from '../../utils/mark';

import { RiInstagramLine, RiFacebookFill, RiLinkedinFill, RiGlobalLine, RiTwitterLine } from 'react-icons/ri';
import { MdOutlineFileCopy, MdDone } from 'react-icons/md';
import Link from 'next/link';
import { MdExtensionOff, MdChevronLeft } from 'react-icons/md';
import MostVisitedPost from '../sectionBlogListArticles/mostVisitedPost';

//prettier-ignore
function SectionBLogArticle({ article, similarArticles , mostViewArticles ,errMost , err }) {




 
  const [copyTextActive, setCopyTextActive] = useState(false);
  const handleCopyButton = async () => {
    setCopyTextActive(true);
       try {await navigator.clipboard.writeText(`https://jamiviz.com/articles/${article.articleData[0].articleUrl}`);} catch (err) {}
  };
 

  const handleClickInsta = () => {   
    window.open(`https://instagram.com`, '_blank')
  };
  const handleClickLinkedin = () => {   
    window.open(`https://linkedin.com`, '_blank')
  };




  const handleClickFacebookCreator = () => {   
    window.open(`https://${article.articleData[0].createdBy.socialMedia.facebook}`, '_blank')
  };
  const handleClickInstaCreator = () => {   
    window.open(`https://${article.articleData[0].createdBy.socialMedia.insta}`, '_blank')
  };

  const handleClickLinkedinCreator = () => {   
    window.open(`https://${article.articleData[0].createdBy.socialMedia.linkedin}`, '_blank')
  };

  const handleClickWebsiteCreator = () => {   
    window.open(`https://${article.articleData[0].createdBy.socialMedia.website}`, '_blank')
  };

  const handleClickTwitterCreator = () => {   
    window.open(`https://${article.articleData[0].createdBy.socialMedia.twitter}`, '_blank')
  };
  const handleClickThreadsCreator = () => {   
    window.open(`https://${article.articleData[0].createdBy.socialMedia.threads}`, '_blank')
  };





const paragStyle = "text-[3.75vw] xs:text-[3vw] sm:text-[2.2vw] md:text-[1.8vw] lg:text-[1.35vw] xl:text-[1.25vw] bl:text-[0.9vw] ml:text-[0.7vw] p-0 m-0 ";
const h2h3Style =  "uppercase   text-[7vw] xs:text-[6vw] sm:text-[5.5vw] md:text-[4vw] lg:text-[2.5vw] xl:text-[2vw] bl:text-[1.5vw] font-medium text-main";

const title =    !err && article && article.articleData && article.length != 0      ? article.articleData[0].title      : "Error 404";








const SimilarArticles = (picSimilarArticle, dateSimilarArticle, nameSimilarArticle , urlSimilarArticle ) => {
    return (
      
       <Link
       
       href={{
        pathname: `${process.env.NEXT_PUBLIC_origin}/articles/${urlSimilarArticle}`
      }}
       className={` flex flex-col items-center md:items-start justify-center gap-4 w-full md:w-1/3 buttonsStyle`}>   
              <div className="flex items-center relative justify-center flex-col w-full  max-w-[550px]  px-2   h-32  md:px-0">
                 <Image width={1000} height={1000}      alt={urlSimilarArticle}   src={picSimilarArticle}   className=" w-full px-6 md:px-0  object-cover h-full " />
        </div>
        <div className="flex px-10 md:px-4 items-center justify-center text-center w-full  flex-col gap-1 md:gap-2 ">
          <p className=" uppercase  text-[11px] md:text-xs  tracking-widest font-medium">
            {nameSimilarArticle}
          </p>
          
          <p className=" text-xs capitalize "> {dateSimilarArticle}</p>
        </div>
     
      </Link>
    );
  };

const CenteredImage = ({ src, alt }) => (
    <Image src={src} alt={alt} width={1920}  height={1500} className="pt-4 m-0 flex items-center justify-center xg--blue- w-full" />
  );





  
  const result =
    !err && article && article.articleData && article.length != 0 ? (
      <div
        className=" xg--blue-400 text-black/80 gap-10 flex   md:px-10  w-full flex-col items-center justify-start py-20  "
        key={article.articleData[0].id}
      >
        <p className=" uppercase text-main  text-xs font-bold  py-1 px-8 border-main/60 border-2 ">
          {article.articleData[0].tags}
        </p>
        <h1 className="text-3xl font-bold max-w-3xl text-center">
          {article.articleData[0].title}
        </h1>
        <h2 className=" text-base max-w-3xl text-center">
          {article.articleData[0].resume}
        </h2>
        <div className="flex flex-row items-center gap-2">
          <div className="flex items-center justify-center flex-col  ">
            <Image
              
              alt="jamiviz_blog"
              src={article.articleData[0].createdBy.picture}
              className="  max-w-[50px] md:max-w-[75px]  object-cover   "
              width={1200}  
              height={1200} 
            />
          </div>
          <div className="flex flex-col items-start justify-center">
            <p className="font-medium text-lg">
              {article.articleData[0].createdBy.creator}
            </p>
            <p className="text-black/60 capitalize">
              {format(
                new Date(article.articleData[0].updatedAt),
                "MMM d, yyyy",{locale: fr,}
              )}
            </p>
          </div>
        </div>
 
        <div className="flex items-center justify-center flex-col max-w-6xl w-full mt-2">
          {article.articleData[0].video ? (
            <div className="bg-backbg/90 w-full flex items-center justify-center md:px-20">
              <iframe
                className="w-full h-[350px] md:h-[600px]"
                src={article.articleData[0].video}
                title="YouTube video player"
                sandbox="allow-scripts allow-same-origin allow-presentation"
                allow=" camera 'none'; microphone 'none';accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <Image
          
            width={800}
            height={800}
            quality={20}

              alt={title}
              src=  {article.articleData[0].images.principale}
              className="     object-cover  w-full  "
             
            />
          )}
        </div>

       <div className="w-full bg-blue-5 items-start justify-center flex gap-10 flex-row lg:pt-10 ">
        <div className="flex items-center justify-center flex-col">
        <div className="  w-full  text-white flex flex-col items-center justify-center   ">
                <Markdown
                  className={`prose max-w-6xl  flex flex-col gap-6  justify-center  w-full xg--red-5 m-0 p-0 `}
                  options={{
                    forceBlock: true,

                    overrides: {
                      h1: {
                        props: {
                          className: "  p-0 m-0", // not used for h1 above
                        },
                      },
                      h2: {
                        props: {
                          className: `${h2h3Style} p-0 m-0`, // premier h3
                        },
                      },
                      h3: {
                        props: {
                          className: `${h2h3Style} pt-10 m-0`, // gros titre
                        },
                      },
                      h4: {
                        props: {
                          className: "text-hp8 font-medium p-0 m-0", // text-testimonial big
                        },
                      },
                      h5: {
                        props: {
                          className:
                            " text-[3vw] sm:text-[8vw] md:text-[0.75vw] pt-4 m-0 text-black/40 font-medium", // text-testimonial small
                        },
                      },
                      h6: {
                        props: {
                          className:
                            " text-hp10 text-black/80 px-2 mt-[-20px] italic", // text- bellow image
                        },
                      },
                      p: {
                        props: {
                          className: paragStyle,
                        },
                      },
                      li: {
                        props: {
                          className: paragStyle,
                        },
                      },

                      ol: {
                        props: {
                          className: paragStyle,
                        },
                      },
                      a: {
                        props: {
                          className: "text-hp10  text-red-800 p-0 m-0 underline",
                        },
                      },
                      br: {
                        props: {
                          className: " p-0 m-0",
                        },
                      },
                      blockquote: {
                        props: {
                          className: " p-4 m-4", // testimonial countainer
                        },
                      },
                      img: {
                        component: CenteredImage,
                      },
                    },
                  }}
                >
                  {article.articleData[0].description}
                </Markdown>
            </div>

        <div className="max-w-5xl flex flex-col  w-full items-center justify-center gap-8 md:gap-6 pt-4 md:pt-10 
        ">
          <div className=" flex flex-col md:flex-row  w-full justify-between pb-6 md:pb-0 gap-4 ">
            <div className="flex flex-row gap-1 items-center justify-center text-[10px]">
            <div className=" border-[1px] text-black/70  uppercase px-6 py-1 border-gray-200 font-bold tracking-[1px] w-fit md:flex items-center justify-center ">
            {article.articleData[0].tags}
            </div>
            <div className=" border-[1px] text-black/70  px-6 py-1 border-gray-200 font-bold tracking-[1px] w-fit md:flex items-center justify-center ">
              Ref : {article.articleData[0].reference}
            </div>
            
            </div>
           
            <div className="flex items-center justify-center">
              <button disabled={copyTextActive} onClick={handleCopyButton} 
              className= {`border-[1px] text-black/70 text-[8px] px-4 py-1 border-gray-200 font-bold tracking-[1px]  flex items-center justify-center hover:cursor-pointer ${copyTextActive == 1 ? "":"hover:bg-gray-50 hover:scale-105 "}  `} >
                {copyTextActive == 1 ?  <MdDone className="w-4 h-4 mr-2" /> : <MdOutlineFileCopy className="w-4 h-4 mr-2" />} COPIER LE LIEN
              </button>
              
      
 
              <Link href="/" rel="noopener noreferrer" target="_blank"className=" btn btn-primary text-xs   ">
              <RiGlobalLine className="w-7 h-7 rounded-full  border-black-300 text-black/70  p-[6px] mx-2 hover:bg-gray-50 hover:scale-125 hover:cursor-pointer" />
              </Link>
           
              <RiInstagramLine onClick={handleClickInsta} className="w-7 h-7 rounded-full  border-black-300 text-black/70  p-[6px] hover:bg-gray-50 hover:scale-125 hover:cursor-pointer" />
              <RiLinkedinFill onClick={handleClickLinkedin} className="w-7 h-7 rounded-full  border-black-300 text-black/70  p-[6px] ml-2 hover:bg-gray-50 hover:scale-125 hover:cursor-pointer" />

            </div>
          </div>
          <div className=" w-full border-t-[1px]    flex items-center justify-center flex-col  border-black/30  ">
            <p className="text-[10px] uppercase bg-white px-4 font-bold text-black/80 -translate-y-2 ">
              À propos de l &apos;auteur
            </p>
            <div className="w-full bg-red-00 flex flex-col md:flex-row py-4 items-center justify-center gap-4 md:gap-0">
              <div className="flex items-center justify-center flex-col w-1/6 bg-red-00 ">
                <Image
                 
                  alt="jamiviz développeur web montreal"
                  src={article.articleData[0].createdBy.picture}
                  className=" max-w-[60px]  md:max-w-[75px]   object-cover   "
                  width={1000}  // Width of your image
                  height={1000} // Height of your image
                />
              </div>
              <div className="w-full flex  flex-col items-center md:items-start text-center md:text-start gap-4 md:gap-2">
                <p className="text-base tracking-wider">
                  {article.articleData[0].createdBy.creator}
                </p>

                <p className="text-sm text-black/60 max-w-xl px-6 md:px-0 md:max-w-max">
                {article.articleData[0].createdBy.descript}
                </p>
                <div className="w-full flex items-center justify-center md:justify-start pt-2">
                  {article.articleData[0].createdBy.socialMedia.facebook ?                    
                  <RiFacebookFill  onClick={handleClickFacebookCreator} className="w-4 h-4  text-black/40 mr-1 hover:bg-gray-50 hover:scale-125 hover:cursor-pointer" />: "" }


                   {article.articleData[0].createdBy.socialMedia.insta ?                    
                  <RiInstagramLine  onClick={handleClickInstaCreator} className="w-4 h-4  text-black/40 mr-1 hover:bg-gray-50 hover:scale-125 hover:cursor-pointer" />: "" }
                   {article.articleData[0].createdBy.socialMedia.linkedin ?                    
                  <RiLinkedinFill  onClick={handleClickLinkedinCreator} className="w-4 h-4  text-black/40 mr-1 hover:bg-gray-50 hover:scale-125 hover:cursor-pointer" />: "" }

                   {article.articleData[0].createdBy.socialMedia.website ?                    
                  <RiGlobalLine  onClick={handleClickWebsiteCreator} className="w-4 h-4  text-black/40 mr-1 hover:bg-gray-50 hover:scale-125 hover:cursor-pointer" />: "" }

                   {article.articleData[0].createdBy.socialMedia.twitter ?                    
                  <RiTwitterLine  onClick={handleClickTwitterCreator} className="w-4 h-4  text-black/40 mr-1 hover:bg-gray-50 hover:scale-125 hover:cursor-pointer" />: "" }
                  {/*
                   {article.articleData[0].createdBy.socialMedia.threads ?                    
                  <RiInstagramLine  onClick={handleClickThreadsCreator} className="w-4 h-4  text-black/40 mr-1 hover:bg-gray-50 hover:scale-125 hover:cursor-pointer" />: "" }
                   */}
                  
                  
                 
                  
                  
                </div>
              </div>
            </div>
          </div>
          {similarArticles && similarArticles.similarArticles_data && similarArticles.similarArticles_data.length === 3 ? 
          
          <div className=" w-full border-t-[1px] border-b-[1px] pb-6    flex items-center justify-center flex-col  border-black/30  ">
          <p className="text-[12px] uppercase bg-white px-4 font-bold text-black/80 -translate-y-2 ">
            Articles à voir
          </p>       
          <div className="w-full  flex flex-col md:flex-row pt-6 gap-10 md:gap-8 items-center md:items-start justify-between ">
            {SimilarArticles(similarArticles.similarArticles_data[0].images.principale,
             format( new Date(similarArticles.similarArticles_data[0].updatedAt,),"MMM d, yyyy",{locale: fr,}),
              truncateText(similarArticles.similarArticles_data[0].title ,50),
               similarArticles.similarArticles_data[0].articleUrl)}
           
            {SimilarArticles(similarArticles.similarArticles_data[1].images.principale, format(
              new Date(similarArticles.similarArticles_data[1].updatedAt,),"MMM d, yyyy" ,{locale: fr,}),
              truncateText(similarArticles.similarArticles_data[1].title ,50),
              similarArticles.similarArticles_data[1].articleUrl)}
                      
            {SimilarArticles(similarArticles.similarArticles_data[2].images.principale, format(
              new Date(similarArticles.similarArticles_data[2].updatedAt,),"MMM d, yyyy",{locale: fr,} ),
              truncateText(similarArticles.similarArticles_data[2].title ,50),
              similarArticles.similarArticles_data[2].articleUrl)}

          </div>
        </div>
          
          : ""}
         
        </div>
        </div>
           
           <div className=" hidden lg:flex items-start justify-start sticky max-w-[400px] top-4 right-0 ">
              {errMost ? (
            <div className=" w-full flex items-center justify-center flex-col">
              <div className="  flex items-center justify-center flex-col w-full py-20 ">
                <Image width={75} height={75} alt="" src="/svg/loading.svg" className="   object-cover   " />
                
              </div>
            </div>
          ) : (
            <MostVisitedPost mostViewArticles={mostViewArticles} err={errMost} />
          )}

           </div>
       </div>
       
      

       
      </div>
    ) : (
      <div className="flex flex-col text-center items-center justify-center text-black/80 ">
          <div className="flex flex-col items-center justify-center sm:mt-20 gap-4 my-20 md:my-40 ">
            <MdExtensionOff   className=" text-black/80 w-8 h-8  md:w-12 md:h-12 " />
            <div className="font-medium text-5xl sm:text-8xl">404</div>
            <div className="font-medium text-black/80  text-sm lg:text-3xl  ">Oops, Page Not Found!</div>

            <button className="  hover:bg-gray-50 hover:scale-110 hover:cursor-pointer ">
              <Link href="/" className=" btn btn-primary text-xs   ">
                <MdChevronLeft className="w-5 h-5 pr-1  " />
                Back To Home
              </Link>
            </button>
          </div>
        </div>
    );

  return (
    <div className="font-poppins bg-white px-6 sm:px-16 md:px-30 bl:px-[10vw]  flex flex-col items-center tracking-wide">
      <Head>
        <title>{title}</title>
        <meta name="description" content={title} />
      </Head>
      {result}
 
    </div>
  );
}

export default SectionBLogArticle;

/*


Heading tags: h1, h2, h3, h4, h5, h6
Paragraph: p
Images: img
Lists: ul, ol, li
Blockquotes: blockquote
Code: code, pre
Links: a
Emphasis: em, strong
Tables: table, thead, tbody, tr, td, th
Breaks: br, hr

 */
